import React from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import logo from '../../assets/pharma-logo.png';
import { FOOTER_HEIGHT } from '../../constants';

interface FooterProps {
    includeLogo: boolean;
}

const Footer = ({includeLogo}: FooterProps) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isSMScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const currentYear = new Date().getFullYear();

    return (
        <Box
            sx={{
                marginTop: 'auto',
                width: '100%',
                position: 'relative',
                bottom: 0,
                borderTop: (theme) => `1px solid ${theme.palette.divider}`,
                background: (theme) => theme.palette.common.white,
                zIndex: '1200',
                display: 'flex',
                alignItems: 'center',
                justifyContent: isSMScreen ? 'center' : 'space-between',
                padding: isSMScreen ? '10px' : '0 37px',
                height: isSMScreen ? FOOTER_HEIGHT.mobile : FOOTER_HEIGHT.desktop,
                flexWrap: 'wrap',
            }}
        >
            <Typography
                align='center'
                data-testid='footer-text'
                sx={{
                    width: isSMScreen ? '100%' : 'auto',
                    marginBottom: isSMScreen ? '8px' : 0,
                    fontSize: '14px',
                    color: 'common.grey1',
                }}
            >
                {t('footer-all-rights-reserved', { year: currentYear })}
            </Typography>
            <Box
                sx={{
                    '& img': {
                        maxHeight: '28px',
                        width: '125px',
                        verticalAlign: 'middle',
                    },
                }}
            >
                {includeLogo && <img src={logo} alt='Pharma Logo' loading='lazy' />}
            </Box>
        </Box>
    );
};

export default Footer;
